/* La Vie - silnik prezentów za 1 zł.
 *
 * Model: prezent = zwykły produkt w cenie 1 zł, oznaczony tagiem gratis_product.
 * Zero rabatów Shopify, więc nie ma czego zgubić na checkoucie.
 *
 * Zasada: suma pozycji koszyka z marek objętych promocją (bez pozycji prezentowych)
 * >= próg  ->  prezent dorzucany automatycznie; poniżej progu -> zdejmowany.
 * Ręczne usunięcie prezentu przez klienta jest respektowane do czasu, aż koszyk
 * spadnie poniżej progu.
 */
(function () {
  'use strict';

  var CFG = [];
  // 07.10.2026: produkty z oferty limitowanej nie licza sie do progu prezentu (lista id z lv-promo-config)
  var WYKL = [];
  try {
    var wyklEl = document.getElementById('LvPromoWykluczone');
    if (wyklEl) WYKL = JSON.parse(wyklEl.textContent) || [];
  } catch (e) {
    WYKL = [];
  }
  try {
    var el = document.getElementById('LvPromoConfig');
    if (el) CFG = JSON.parse(el.textContent) || [];
  } catch (e) {
    CFG = [];
  }
  if (!CFG.length) return;

  var SEKCJE = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  var KLUCZ_DODANY = 'lv_prezent_dodany:';
  var KLUCZ_USUNIETY = 'lv_prezent_usuniety:';
  var KLUCZ_WYBOR = 'lv_prezent_wybor:';
  var MAX_PROB = 3; // ile razy z rzędu silnik może poprawiać koszyk, zanim odpuści
  var proby = 0;
  var zajete = false;
  var wlasneZadanie = false;
  var timer = null;

  function grosze(v) {
    return (v / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function flaga(magazyn, klucz, wartosc) {
    try {
      if (wartosc === undefined) return magazyn.getItem(klucz) === '1';
      if (wartosc) magazyn.setItem(klucz, '1');
      else magazyn.removeItem(klucz);
    } catch (e) {}
    return false;
  }

  function czytajWybor(handle) {
    try {
      var v = JSON.parse(sessionStorage.getItem(KLUCZ_WYBOR + handle) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }

  function zapiszWybor(handle, wybor) {
    try { sessionStorage.setItem(KLUCZ_WYBOR + handle, JSON.stringify(wybor)); } catch (e) {}
  }

  /* Sloty w kolejności zapamiętanej, uzgodnione z faktyczną zawartością koszyka:
     zostają tylko te zapamiętane pozycje, które koszyk potwierdza; resztę dokładamy z koszyka. */
  function wyborZKoszyka(handle, linie) {
    var ile = {};
    linie.forEach(function (l) { ile[l.variant_id] = (ile[l.variant_id] || 0) + l.quantity; });
    var wynik = [];
    czytajWybor(handle).forEach(function (v) {
      if (ile[v] > 0) { wynik.push(v); ile[v]--; }
    });
    linie.forEach(function (l) {
      while (ile[l.variant_id] > 0) { wynik.push(l.variant_id); ile[l.variant_id]--; }
    });
    zapiszWybor(handle, wynik);
    return wynik;
  }

  function mapaPrezentow() {
    var m = {};
    CFG.forEach(function (p) {
      p.prezenty.forEach(function (g) {
        m[g.id] = p.handle;
      });
    });
    return m;
  }

  /* Reguła: JEDEN prezent na każdy pełny próg promocji.
     Przy progu 599 zł: 599-1197 zł -> 1 prezent, od 1198 zł -> 2 prezenty itd.
     Każda promocja liczy się osobno. Pozycje prezentowe nie wchodzą do sumy,
     a wszystko ponad należną liczbę (np. dorzucone ręcznie z karty produktu) jest usuwane. */
  function analizuj(cart) {
    var prezenty = mapaPrezentow();
    var plan = [];
    var stan = [];
    var najblizszy = null;

    CFG.forEach(function (p) {
      var suma = 0;
      var linie = [];
      var ile = 0;

      // Dwa tryby kwalifikacji:
      //  - kwotowy: suma pozycji z marek promocji / próg (prezent za każdy pełny próg),
      //  - za sztukę: lista produktów kwalifikujących z kolekcji (prezent do każdej sztuki,
      //    np. maska do każdego kremu pod oczy) - wtedy próg jest pusty.
      var zaSztuke = p.kwalifikujace && p.kwalifikujace.length > 0;
      var sztuk = 0;

      cart.items.forEach(function (it) {
        var czyj = prezenty[it.variant_id];
        if (czyj) {
          if (czyj === p.handle) {
            linie.push(it);
            ile += it.quantity;
          }
          return; // prezenty nie liczą się do progu
        }
        if (WYKL.indexOf(it.product_id) > -1) return; // oferta limitowana poza promocją
        if (zaSztuke) {
          if (p.kwalifikujace.indexOf(it.product_id) > -1) sztuk += it.quantity;
          return;
        }
        if (p.marki.indexOf(it.vendor) > -1) suma += it.final_line_price;
      });

      var dostepne = p.prezenty.filter(function (g) { return g.dostepny; });
      var nalezne = zaSztuke ? sztuk : (p.prog > 0 ? Math.floor(suma / p.prog) : 0);

      if (!nalezne) {
        linie.forEach(function (l) { plan.push({ akcja: 'usun', key: l.key }); });
        flaga(sessionStorage, KLUCZ_USUNIETY + p.handle, false);
        flaga(sessionStorage, KLUCZ_DODANY + p.handle, false);
        if (!zaSztuke && suma > 0 && dostepne.length) {
          var brak = p.prog - suma;
          if (!najblizszy || brak < najblizszy.brakuje) {
            najblizszy = { p: p, brakuje: brak };
          }
        }
        return;
      }
      if (!dostepne.length && !linie.length) return; // prezenty wyczerpane

      var usuniety = flaga(sessionStorage, KLUCZ_USUNIETY + p.handle);
      if (!ile && flaga(sessionStorage, KLUCZ_DODANY + p.handle) && !usuniety) {
        flaga(sessionStorage, KLUCZ_USUNIETY + p.handle, true); // klient sam wyrzucił prezent
        usuniety = true;
      }

      if (ile > nalezne) {
        // nadmiar zdejmujemy, zaczynając od ostatnich pozycji
        var doZdjecia = ile - nalezne;
        for (var i = linie.length - 1; i >= 0 && doZdjecia > 0; i--) {
          var zostaw = Math.max(0, linie[i].quantity - doZdjecia);
          doZdjecia -= linie[i].quantity - zostaw;
          plan.push({ akcja: 'ilosc', key: linie[i].key, ile: zostaw });
        }
      } else if (ile < nalezne && !usuniety && dostepne.length) {
        plan.push({ akcja: 'dodaj', id: dostepne[0].id, handle: p.handle, ile: nalezne - ile });
      }

      // aktualny wybór: jedna pozycja na każdy należny prezent.
      // Kolejność slotów bierzemy z zapamiętanego wyboru klienta (sessionStorage), a nie z kolejności
      // linii koszyka - Shopify wstawia nowe linie na górę, więc po zmianie prezentu sloty by się zamieniały.
      var wybor = wyborZKoszyka(p.handle, linie);

      stan.push({
        p: p, osiagniety: true, nalezne: nalezne, wKoszyku: ile,
        wybor: wybor, dostepne: dostepne, usuniety: usuniety && !ile
      });
    });

    if (!stan.length && najblizszy) {
      stan.push({ p: najblizszy.p, osiagniety: false, brakuje: najblizszy.brakuje });
    }

    return { plan: plan, stan: stan };
  }

  function zadanie(url, opcje) {
    wlasneZadanie = true;
    return fetch(url, opcje).then(function (r) {
      wlasneZadanie = false;
      return r;
    }, function (e) {
      wlasneZadanie = false;
      throw e;
    });
  }

  function wykonaj(plan) {
    var lancuch = Promise.resolve();
    plan.forEach(function (z) {
      lancuch = lancuch.then(function () {
        if (z.akcja === 'dodaj') {
          return zadanie('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: z.id, quantity: z.ile || 1, properties: { _prezent: z.handle } }]
            })
          }).then(function (r) {
            if (r && r.ok) {
              flaga(sessionStorage, KLUCZ_DODANY + z.handle, true);
              return;
            }
            // Shopify odrzucił dodanie (najczęściej prezent wyprzedany między renderem a dodaniem):
            // oznaczamy wariant jako niedostępny, żeby nie próbować go w kółko
            CFG.forEach(function (p) {
              p.prezenty.forEach(function (g) { if (g.id === z.id) g.dostepny = false; });
            });
          });
        }
        return zadanie('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: z.key, quantity: z.akcja === 'ilosc' ? z.ile : 0 })
        });
      });
    });
    return lancuch.then(odswiezSekcje).then(odswiezStroneKoszyka);
  }

  // Na /cart silnik przerysowywał tylko mini-koszyk i licznik, więc dorzucony
  // (albo zdjęty) prezent nie pojawiał się na liście pozycji - user widział
  // nieaktualny koszyk. Sekcje strony koszyka mają własne ID per szablon, więc
  // zamiast zgadywać je z Section Rendering API przeładowujemy stronę, ale tylko
  // gdy faktycznie coś się zmieniło i nie częściej niż raz na 5 sekund
  // (zabezpieczenie przed pętlą, gdyby prezent nie dał się dodać).
  function odswiezStroneKoszyka() {
    if (!/^\/cart(\/|$|\?)/.test(location.pathname + location.search)) return;
    var teraz = Date.now();
    var ostatnio = parseInt(sessionStorage.getItem('lvPromoReload') || '0', 10);
    if (teraz - ostatnio < 5000) return;
    sessionStorage.setItem('lvPromoReload', String(teraz));
    location.reload();
  }

  // ta sama informacja co w side carcie, ale na pełnej stronie koszyka: wiersz
  // prezentu dostaje badge zamiast licznika ilości (ilości i tak nie zmieniamy)
  function oznaczKoszyk(ids) {
    if (!/^\/cart/.test(location.pathname)) return;
    // PUŁAPKA: na pełnej stronie koszyka linki pozycji nie mają parametru variant,
    // więc prezent rozpoznajemy po adresie produktu z konfiguracji promocji
    var adresy = [];
    CFG.forEach(function (p) {
      p.prezenty.forEach(function (g) { if (g.url) adresy.push(g.url.split('?')[0]); });
    });
    var wiersze = document.querySelectorAll('.cart-item');
    Array.prototype.forEach.call(wiersze, function (tr) {
      var a = tr.querySelector('a[href]');
      if (!a) return;
      var href = a.getAttribute('href').split('?')[0];
      if (adresy.indexOf(href) === -1) return;
      tr.classList.add('lv-gift-line');
      var pole = tr.querySelector('.cart-item__quantity');
      if (pole && !pole.querySelector('.lv-gift-line__badge')) {
        var b = document.createElement('span');
        b.className = 'lv-gift-line__badge';
        b.textContent = 'PREZENT ZA 1 ZŁ';
        pole.insertBefore(b, pole.firstChild);
      }
    });
  }

  function odswiezSekcje() {
    return zadanie('/?sections=' + SEKCJE.join(','))
      .then(function (r) { return r.json(); })
      .then(function (dane) {
        SEKCJE.forEach(function (id) {
          var cel = document.getElementById(id);
          if (!cel || !dane[id]) return;
          var parsed = new DOMParser().parseFromString(dane[id], 'text/html')
            .querySelector('.shopify-section');
          if (parsed) cel.innerHTML = parsed.innerHTML;
        });
      })
      .catch(function () {});
  }

  function oznaczLinie() {
    var ids = mapaPrezentow();
    oznaczKoszyk(ids);
    Object.keys(ids).forEach(function (id) {
      var linki = document.querySelectorAll('#mini-cart a[href*="variant=' + id + '"]');
      Array.prototype.forEach.call(linki, function (a) {
        var li = a.closest('li');
        if (!li || li.classList.contains('lv-gift-line')) return;
        li.classList.add('lv-gift-line');
        // badge wchodzi w miejsce licznika ilości - marka, tytuł i ceny zostają jak przy zwykłych produktach
        var ilosc = li.querySelector('.product-quantity');
        if (ilosc && !ilosc.querySelector('.lv-gift-line__badge')) {
          // NIE czyścimy kontenera - obok licznika ilości siedzi w nim cena
          var b = document.createElement('span');
          b.className = 'lv-gift-line__badge';
          b.textContent = 'PREZENT ZA 1 ZŁ';
          ilosc.insertBefore(b, ilosc.firstChild);
        }
      });
    });
  }

  // na pełnej stronie koszyka nie ma kontenera z side cartu - dokładamy własny
  // pod listą pozycji, żeby wybór prezentu był dostępny w obu miejscach
  function kontenerKoszyka() {
    if (!/^\/cart/.test(location.pathname)) return null;
    var jest = document.getElementById('lv-promo-cart');
    if (jest) return jest;
    var lista = document.querySelector('.cart__contents');
    if (!lista) return null;
    var div = document.createElement('div');
    div.id = 'lv-promo-cart';
    div.className = 'lv-promo-cart--strona';
    lista.appendChild(div);
    return div;
  }

  function render(stan) {
    oznaczLinie();
    var cel = document.getElementById('lv-promo-cart') || kontenerKoszyka();
    if (!cel) return;
    if (!stan.length) {
      cel.innerHTML = '';
      return;
    }

    var html = '';
    stan.forEach(function (s) {
      if (!s.osiagniety) {
        html += '<p class="lv-cart-promo lv-cart-promo--brak">' +
          'Do <strong>prezentu za ' + s.p.cena_txt + '</strong> (' + s.p.marka_txt + ') brakuje Ci ' +
          '<strong>' + grosze(s.brakuje) + '</strong>' +
          ' <a href="' + s.p.url + '">Dobierz produkty</a></p>';
        return;
      }
      if (s.usuniety && !s.wKoszyku) {
        html += '<p class="lv-cart-promo lv-cart-promo--ok">' +
          (s.nalezne > 1
            ? 'Prezenty za ' + s.p.cena_txt + ' czekają (' + s.nalezne + ' szt.). '
            : 'Prezent za ' + s.p.cena_txt + ' czeka. ') +
          '<button type="button" class="lv-cart-promo__wroc" data-promo="' + s.p.handle + '">' +
          (s.nalezne > 1 ? 'Dodaj prezenty' : 'Dodaj prezent') + '</button></p>';
        return;
      }
      html += '<p class="lv-cart-promo lv-cart-promo--ok">' +
        (s.nalezne > 1
          ? 'Prezenty za ' + s.p.cena_txt + ' dodane do koszyka (' + s.nalezne + ' szt.).'
          : 'Prezent za ' + s.p.cena_txt + ' dodany do koszyka.') + '</p>';
      if (s.dostepne.length > 1 && s.wKoszyku) {
        if (s.nalezne > 1) { html += '<div class="lv-cart-promo__wybory">'; }
        for (var slot = 0; slot < s.nalezne; slot++) {
          var aktualny = s.wybor[slot];
          html += '<div class="lv-cart-promo__wybor lv-cart-promo__wybor--siatka"><span class="lv-cart-promo__wybor-tytul">' +
            (s.nalezne > 1 ? 'Wybierz prezent ' + (slot + 1) + ' z ' + s.nalezne + ':' : 'Wybierz prezent:') + '</span>';
          s.dostepne.forEach(function (g) {
            var zaznaczony = g.id === aktualny;
            html += '<button type="button" class="lv-cart-promo__opcja' + (zaznaczony ? ' is-aktywny' : '') +
              '" data-promo="' + s.p.handle + '" data-slot="' + slot + '" data-wariant="' + g.id + '"' +
              (zaznaczony ? ' disabled' : '') + '>' +
              (g.obraz ? '<img src="' + g.obraz + '" alt="" width="34" height="34">' : '') +
              '<span class="lv-cart-promo__opcja-tekst">' +
                '<span class="lv-cart-promo__opcja-marka">' + (g.marka || '') + '</span>' +
                '<span class="lv-cart-promo__opcja-nazwa">' + (g.podtytul || g.tytul) + '</span>' +
              '</span></button>';
          });
          html += '</div>';
        }
        if (s.nalezne > 1) { html += '</div>'; }
      }
    });
    cel.innerHTML = html;
  }

  function odswiez() {
    if (zajete) return Promise.resolve();
    zajete = true;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var w = analizuj(cart);
        if (w.plan.length && proby < MAX_PROB) {
          proby++;
          return wykonaj(w.plan).then(function () {
            zajete = false;
            return odswiez();
          });
        }
        proby = 0;
        render(w.stan);
        zajete = false;
      })
      .catch(function () { zajete = false; });
  }

  function zaplanuj() {
    clearTimeout(timer);
    timer = setTimeout(odswiez, 180);
  }

  // klik w wybór prezentu / powrót prezentu
  document.addEventListener('click', function (e) {
    var opcja = e.target.closest && e.target.closest('.lv-cart-promo__opcja');
    if (opcja) {
      e.preventDefault();
      var handle = opcja.dataset.promo;
      var nowy = parseInt(opcja.dataset.wariant, 10);
      var slot = parseInt(opcja.dataset.slot || '0', 10);
      var prezenty = mapaPrezentow();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var moje = cart.items.filter(function (it) { return prezenty[it.variant_id] === handle; });
          var wybor = wyborZKoszyka(handle, moje);
          if (slot >= wybor.length) wybor.push(nowy); else wybor[slot] = nowy;
          zapiszWybor(handle, wybor);

          var cel = {};
          wybor.forEach(function (v) { cel[v] = (cel[v] || 0) + 1; });

          // istniejące linie tylko zmieniamy ilościowo (zostają na swoim miejscu w koszyku);
          // nową linię dodajemy wyłącznie dla wariantu, którego jeszcze w koszyku nie ma
          var plan = [];
          var wKoszyku = {};
          moje.forEach(function (it) {
            wKoszyku[it.variant_id] = true;
            var chce = cel[it.variant_id] || 0;
            if (chce !== it.quantity) plan.push({ akcja: 'ilosc', key: it.key, ile: chce });
          });
          Object.keys(cel).forEach(function (v) {
            if (!wKoszyku[v]) plan.push({ akcja: 'dodaj', id: parseInt(v, 10), handle: handle, ile: cel[v] });
          });
          return wykonaj(plan).then(odswiez);
        });
      return;
    }
    var wroc = e.target.closest && e.target.closest('.lv-cart-promo__wroc');
    if (wroc) {
      e.preventDefault();
      flaga(sessionStorage, KLUCZ_USUNIETY + wroc.dataset.promo, false);
      flaga(sessionStorage, KLUCZ_DODANY + wroc.dataset.promo, false);
      odswiez();
    }
  });

  document.addEventListener('cart:updated', zaplanuj);
  document.addEventListener('cartdrawer:opened', function () { oznaczLinie(); zaplanuj(); });

  var oryginalnyFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var wlasne = wlasneZadanie;
    return oryginalnyFetch.apply(this, args).then(function (res) {
      try {
        var u = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        if (!wlasne && /\/cart\/(add|change|update|clear)/.test(u)) zaplanuj();
      } catch (e) {}
      return res;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', zaplanuj);
  } else {
    zaplanuj();
  }

  /* ── Dodawanie do koszyka z podpowiedzi wyszukiwarki ─────────────────────────
     Podpowiedzi renderują się WEWNĄTRZ formularza wyszukiwarki, więc nie można
     tam użyć <form> (przeglądarka usuwa zagnieżdżone formularze i klik wysyłał
     wyszukiwanie). Stąd zwykły przycisk z data-wariant i delegowany listener -
     przeżywa przerysowanie listy po każdym wpisanym znaku. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lv-ps-dodaj');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = btn.getAttribute('data-wariant');
    if (!id) return;
    // PUŁAPKA: przycisk ma w środku dwa <span> (pełna i krótka etykieta), więc
    // podmiana przez textContent skleja je w "Dodaj do koszykaDo koszyka" przy
    // przywracaniu. Zapamiętujemy i odtwarzamy cały innerHTML.
    var etykieta = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Dodaję...';
    zadanie('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return odswiezSekcje(); })
      .then(function () {
        btn.textContent = 'Dodano';
        setTimeout(function () { btn.innerHTML = etykieta; btn.disabled = false; }, 1500);
      })
      .catch(function () {
        btn.innerHTML = etykieta;
        btn.disabled = false;
      });
  });

})();
